'use strict';

// const $ = require('jquery');

const lightpick = require('lightpick');
const { DateTime } = require('luxon');

const dates = require('util/dates');
const minBy = require('lodash/minBy');
const maxBy = require('lodash/maxBy');
const has = require('lodash/has');
const values = require('lodash/values');

function controller(inventoryService, locale, $scope, $timeout, $attrs) {
    const vm = this;

    const prodSeasonNo = $attrs.prodSeasonNo;
    const facilityNo = $attrs.facilityNo;
    const singleItemOnly = $attrs.singleItemOnly === 'true';
    const now = dates.moment();

    let minDate = null;
    let maxDate = null;
    let excludedDates = [];
    let calendar = null;
    let performanceList = [];
    let selectedDate = null;
    let selectedPerformances = null;

    // Loading by default
    vm.loading = true;
    vm.calendarVisible = false;
    vm.timesList = [];
    vm.priceTypes = {};
    vm.timeSelected = null;
    vm.timeInput = null;
    vm.formIsValid = false;
    vm.errors = [];
    vm.showAddMinusButtons = singleItemOnly ? false : true;

    vm.init = () => {
        inventoryService.getFoodAndDrinkPerformances(prodSeasonNo, facilityNo).then(response => {
            let performanceDates = [];

            // Avoid loops if you can, try using map, filter, find (lodash),
            // reduce, etc. Reduce is your best friend, learnt it, love it.
            performanceList = response.data.map(performance => {
                performance.date_moment = dates.moment(performance.perf_date);

                // Store date for reference later
                performanceDates.push(
                    performance.date_moment.format('YYYY-MM-DD')
                );

                // Return the augmented performance
                return performance;
            });

            // When doing mins and maxes, it's a good idea to look at
            // the numerical value, so lets use valueOf to grab the seconds
            minDate = minBy(performanceList, performance => {
                return performance.date_moment.valueOf();
            }).date_moment;

            // Same for this
            maxDate = maxBy(performanceList, performance => {
                return performance.date_moment.valueOf();
            }).date_moment;

            // Moment has a clone method!
            let date = minDate.clone();

            // I'm sure there's a way to get rid of this loop
            for (date; date.isBefore(maxDate); date.add(1, 'day')) {
                const searchedDate = date.clone();
                const formattedSearchedDate = searchedDate.format('YYYY-MM-DD');

                if (performanceDates.indexOf(formattedSearchedDate) === -1) {
                    excludedDates.push(searchedDate);
                }
            }

            // Setup calendar
            setupCalendar();

            // Watch date changes
            $scope.$watch(() => selectedDate, processDateChange, true);
        }).finally(() => {
            vm.loading = false;
        });
    };

    vm.timeChanged = function() {
        if (!vm.timeInput) {
            return false;
        }

        vm.timeSelected = vm.timeInput;
        vm.priceTypes = {};

        // No way around this loop, well, there is but meh
        vm.timeSelected.prices.forEach(price => {
            vm.priceTypes[price.price_type] = singleItemOnly ? 1 : 0;
        });

        validateForm();
    }

    vm.removeTickets = function(priceTypeId) {
        if (has(vm.priceTypes, priceTypeId) === false) {
            vm.priceTypes[priceTypeId] = 0;
        }

        if (parseInt(vm.priceTypes[priceTypeId], 10) > 0) {
            vm.priceTypes[priceTypeId]--;
        }

        validateForm();
    }

    vm.addTickets = function(priceTypeId) {
        if (has(vm.priceTypes, priceTypeId) === false) {
            vm.priceTypes[priceTypeId] = 0;
        }

        if (parseInt(vm.priceTypes[priceTypeId], 10) < 10) {
            vm.priceTypes[priceTypeId]++;
        }

        validateForm();
    }

    vm.checkout = function() {
        vm.loading = true;

        let checkoutData = {
            performanceId: vm.timeSelected.prices[0].perf_no,
            zoneId: vm.timeSelected.value,
            priceTypes: vm.priceTypes
        }

        vm.errors = [];

        inventoryService.foodAndDrinkCheckout(checkoutData).then(response => {
            if (response.data.status === 'fail') {
                vm.errors.push(response.data.error);
            }

            if (response.data.status === 'success') {
                // Internet explorer has issues with assign
                window.location.href = response.data.redirect;
            }
        }).catch(error => {
            vm.errors.push(error);
        }).finally(() => {
            vm.loading = false;
        });
    }

    function setupCalendar() {
        const parent = '.global-nav__calendar-inner';
        let minYear = parseInt(minDate.format('Y'), 10);
        let maxYear = parseInt(maxDate.format('Y'), 10);
        minYear = minYear ? minYear : parseInt(now.format('Y'), 10);
        maxYear = maxYear ? maxYear : parseInt(now.format('Y'), 10);

        // Initialise the date picker
        calendar = new lightpick({
            lang: locale,
            field: document.querySelector('.global-nav-date__input'),
            parentEl: parent,
            dropdowns: {
                years: {
                    min: minYear,
                    max: maxYear,
                },
                months: true,
            },
            numberOfMonths: 1,
            numberOfColumns: 1,
            singleDate: true,
            minDate: minDate,
            maxDate: maxDate,
            hoveringTooltip: false,
            autoclose: false,
            hideOnBodyClick: false,
            disableDates: excludedDates,
            onSelect: date => {
                $timeout(() => {
                    // Set the date
                    selectedDate = date;

                    vm.calendarVisible = false;
                });
            },
            onOpen: () => {
                $timeout(() => {
                    vm.calendarVisible = true;
                });
            },
            onClose: () => {
                $timeout(() => {
                    vm.calendarVisible = false;
                });
            }
        });

        return calendar;
    }

    // function processDateChange(newVal, oldVal) is the actual signature but
    // having because oldVal is unused, it fails the linting process
    function processDateChange(newVal) {
        if (vm.loading || !newVal) {
            return false;
        }

        selectedPerformances = performanceList.filter(performance => {
            return performance.date_moment.format('YYYY-MM-DD') === newVal.format('YYYY-MM-DD');
        });

        // Reset the old lists
        vm.timesList = [];
        vm.timeSelected = null;

        if (!selectedPerformances || selectedPerformances.lenth === 0) {
            return false;
        }

        vm.timesList = buildTimes(selectedPerformances);

        vm.timeInput = vm.timesList[0];

        vm.timeChanged();
    }

    function buildTimes(performances) {
        if (!performance) {
            return [];
        }

        const times = performances.reduce((times, perf) => {
            return perf.pricing.reduce((times, pricing) => {
                let zoneId = parseInt(pricing.zone_no, 10);

                // Format time to something usable (assuming the time is in the format 8am OR 8.30am OR 8:30am)
                const fullTime = pricing.description.toUpperCase().replace(/(\d+)([:\.](\d{2}))?(\w{2})?/, function (match, hour, ignore, minutes, meridiem) {
                    hour = meridiem === 'PM' && hour !== '12' ? parseInt(hour, 10) + 12 : hour;
                    hour = String(hour).padStart(2, '0');
                    minutes = !minutes ? '00' : minutes;
                    return `${hour}:${minutes}`;
                });

                const thisPerfDateTime = DateTime.fromFormat(perf.date_moment.format('YYYY-MM-DD ') + fullTime, 'yyyy-MM-dd hh:mm');
                if (thisPerfDateTime < now) {
                    // Skip if the before NOW
                    return times;
                }

                // We use lodash.has which is slightly better
                // than doing messy find (and easier to read)
                if (!has(times, zoneId)) {
                    times[zoneId] = {
                        value: pricing.zone_no,
                        desc: pricing.description,
                        prices: [],
                    };
                }
                times[zoneId].prices.push(pricing);

                return times;
            }, times);
        }, {});

        // Flatten the object
        return values(times);
    }

    function validateForm() {
        if (!vm.priceTypes) {
            return (vm.formIsValid = false);
        }

        let selectedPriceType = false;

        for (let priceType in vm.priceTypes) {
            if (selectedPriceType) {
                continue;
            }

            if (parseInt(vm.priceTypes[priceType], 10)) {
                selectedPriceType = true;
            }
        }

        if (!selectedPriceType) {
            return (vm.formIsValid = false);
        }

        vm.formIsValid = true;
    }

    return vm;
}

module.exports = [
    'inventoryService', 'locale', '$scope', '$timeout', '$attrs', controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/FoodAndDrinks.js